// Product maturity section configuration
// Defines fields for product stage and validation status
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for maturity section
export const maturitySectionSchema = z.object({
  hasMvp: z.string().min(1, 'Este campo es requerido'),
  startupStage: z.string().min(1, 'Este campo es requerido'),
  hasValidatedWithUsers: z.string().min(1, 'Este campo es requerido'),
});

export type MaturitySectionData = z.infer<typeof maturitySectionSchema>;

// Section config
export const maturitySection: SectionConfig = {
  id: 'maturity',
  titleKey: 'Estado del producto / madurez',
  descriptionKey: 'Indica el estado actual de tu producto y startup',
  validationSchema: maturitySectionSchema,
  fields: [
    {
      name: 'hasMvp',
      type: 'radio',
      label: '¿Tienes MVP, prototipo o producto en mercado?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
        { value: 'soon', label: 'Pronto' },
      ],
    },
    {
      name: 'startupStage',
      type: 'radio',
      label: '¿En qué etapa se encuentra la startup?',
      required: true,
      options: [
        { value: 'pre-seed', label: 'Pre-semilla' },
        { value: 'seed', label: 'Semilla' },
        { value: 'early', label: 'Temprana' },
        { value: 'growth', label: 'Crecimiento' },
        { value: 'expansion', label: 'Expansión' },
        { value: 'exit', label: 'Salida' },
      ],
    },
    {
      name: 'hasValidatedWithUsers',
      type: 'radio',
      label: '¿Has validado el producto con usuarios reales?',
      required: true,
      options: [
        { value: 'yes', label: 'Sí' },
        { value: 'no', label: 'No' },
      ],
    },
  ],
};
